(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('ModalBrandController', ModalBrandController);

    /** @ngInject */
    function ModalBrandController(BrandService, FlyersService, onFlyerForm, brand, toastr, $scope, $uibModalInstance, $translate, $localStorage) {
        var vm = this;
        const MAX_IMAGE_SIZE = 10240;
        const UPLOAD_IMAGE_CONTEXT = "image";
        const DEFAULT_PAGE = '0';
        const DEFAULT_ITEMS_PER_PAGE = '40';

        vm.filterChange = filterChange
        vm.brands = [];
        vm.brand = brand;
        vm.init = init;
        vm.brandFilter = { "id": "", "name": "" };
        vm.createBrand = createBrand;
        vm.disableButtonCreate = disableButtonCreate;
        vm.disableButtonEdit = disableButtonEdit;
        vm.loadingBrands = false;
        vm.getBrandById = getBrandById;
        vm.removeBrand = removeBrand;
        vm.editBrand = editBrand;
        vm.clearResults = clearResults;
        vm.editing = false;
        vm.onFlyerForm = onFlyerForm;
        vm.editCancel = editCancel;
        vm.close = close;
        vm.brandData = { name: '', logo: null };
        vm.isUploading = false;
        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.submitLoading = false;

        function init() {
            vm.brandFilter = { "id": "", "name": ""  };
            vm.brandData = { name: '', logo: null };
            vm.editing = true;
            if (vm.onFlyerForm) {
                getBrandById(brand);
            }
            filterChange(vm.brandFilter.name);
            vm.changeButtons();
        }

        function clearResults() {
            vm.brands = [];
        }

        vm.changeButtons = function() {
            if (vm.editing) {
                vm.button = "brand.buttons.save";
            } else {
                vm.button = "brand.buttons.create";
            }
        }


        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        function filterChange() {
            if (vm.editing) return;
            vm.loadingBrands = true;
            if (!vm.brandFilter.name) {
                vm.brandFilter.name = "";
            }
            BrandService.findBrand(vm.brandFilter.name, DEFAULT_PAGE, DEFAULT_ITEMS_PER_PAGE).then(function (result) {
                vm.brands = result.data.content.slice();
                vm.loadingBrands = false;
            }, function (_) {
                vm.loadingBrands = false;
            });
        }

        function createBrand() {
            if (vm.submitLoading) return;
            vm.submitLoading = true;
            vm.brandData.name = vm.brandFilter.name;
            vm.loadingBrands = true;

            return BrandService.createBrand(vm.brandData).then(function(response) {
                vm.submitLoading = false;
                toastr.success($translate.instant(getTranslateKey(vm.isImmoContext,'brand.messages.success.create')));
                vm.loadingBrands = false;
                vm.editing = false;
                vm.init();

                if (vm.onFlyerForm) {
                    $uibModalInstance.close(response.data);
                }

                return response;
            }).catch(function(error) {
                if (vm.brandData.name.length > 40) {
                    vm.submitLoading = false;
                    toastr.warning($translate.instant(getTranslateKey(vm.isImmoContext,'brand.messages.warning.exceed-char')));
                    vm.loadingBrands = false;
                } else {
                    vm.submitLoading = false;
                    toastr.warning($translate.instant(getTranslateKey(vm.isImmoContext,'brand.messages.warning.alreadyExists')));
                    vm.loadingBrands = false;
                }

                return $q.reject(error);
            });
        }

        function getBrandById(brand) {
            if (brand.id) {
                BrandService.getBrandById(brand.id).then(function (result) {
                    vm.editing = true;
                    vm.changeButtons();
                    vm.brandFilter = result.data;
                    vm.brandData = result.data;
                    vm.clearResults();
                }, function (_) {
                    toastr.warning($translate.instant(getTranslateKey(vm.isImmoContext,'brand.messages.warning.notFound')));
                    vm.loadingBrands = false;
                });
            } else {
                var presetName = brand && brand.name != null ? String(brand.name) : "";
                vm.brandFilter = { "id": "", "name": presetName };
                vm.brandData = { name: presetName, logo: null };
            }
        }

        function editBrand() {

            if (vm.submitLoading) return;
            vm.submitLoading = true;

            return BrandService.editBrand(vm.brandFilter).then(function(response) {
                vm.editing = false;
                vm.init();
                vm.submitLoading = false;
                toastr.success($translate.instant(getTranslateKey(vm.isImmoContext,'brand.messages.success.edit')));

                if (vm.onFlyerForm) {
                    $uibModalInstance.close(response.data);
                }

                return response;
            }).catch(function(error) {
                vm.submitLoading = false;
                toastr.warning($translate.instant(getTranslateKey(vm.isImmoContext, 'brand.messages.warning.alreadyExists')));

                if (!vm.onFlyerForm) {
                    vm.editing = false;
                    vm.init();
                }

                return $q.reject(error);
            });
        }

        function removeBrand(brand) {
            BrandService.removeBrand(brand.id).then(function (_) {
                vm.brandFilter.name = "";
                vm.init();
                toastr.success($translate.instant(getTranslateKey(vm.isImmoContext,'brand.messages.success.remove')));
                vm.loadingBrands = false;
            }, function (_) {
                toastr.warning($translate.instant(getTranslateKey(vm.isImmoContext,'brand.messages.warning.withRegisteredProducts')));
                vm.loadingBrands = false;
            });
        }

        vm.removeBrandImage = function() {
            vm.brandData.logo = null;
            $scope.PreviewImage = null;

            vm.isUploading = false;
        };

        function disableButtonCreate() {
            return vm.loadingBrands || !vm.brandFilter.name || vm.brandFilter.name.trim().length === 0;
        }


        function disableButtonEdit() {
            if (vm.brandFilter.name.length === 0) return true;
            if (vm.brands.id === "") return true;
        }

        function editCancel() {
            vm.editing = false;
            vm.init();
        }

        function close () {
            $uibModalInstance.close(vm.brandData);
        }

        vm.setBrand = function () {
            if (vm.brandForm.$invalid) {
                angular.forEach(vm.brandForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                vm.submitLoading = false;
                return;
            }

            if (vm.brandData.id) {
                editBrand().then(function (response) {
                    if (vm.onFlyerForm) {
                        close();
                    }
                });
            } else {
                createBrand().then(function () {
                    close();
                });
            }
        };

        vm.cancelActions = function() {
            close();
        };

        vm.openInput = function() {
            document.getElementById('upload-photo').click();
        };

        vm.handleLogoSelect = function(e) {
            var files = e.currentTarget.files;
            if (!files || !files.length) return;

            if (files.length > 1) {
                toastr.error($translate.instant("flyers.messages.error.image.single-only"));
                e.currentTarget.value = null;
                return;
            }

            var file = files[0];

            if (file.size / 1024 > MAX_IMAGE_SIZE) {
                toastr.error($translate.instant("flyers.messages.error.image.limit-size"));
                e.currentTarget.value = null;
                return;
            }

            var validTypes = ['image/jpeg', 'image/png', 'image/webp'];
            if (validTypes.indexOf(file.type) === -1) {
                toastr.error($translate.instant("flyers.messages.error.image.file-type"));
                e.currentTarget.value = null;
                return;
            }

            vm.isUploading = true;
            var reader = new FileReader();

            reader.onload = function(e) {
                $scope.PreviewImage = e.target.result;

                var formData = new FormData();
                formData.append('file', file);
                formData.append('context', UPLOAD_IMAGE_CONTEXT);

                var config = {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                };
                FlyersService.uploadFile(file, UPLOAD_IMAGE_CONTEXT)
                    .then(function(response) {
                        if (response.data === null) {
                            toastr.error($translate.instant("flyers.messages.error.image.upload-failed"));
                        } else {
                            vm.brandData.logo = response.data.path;
                        }
                    })
                    .catch(function(error) {
                        if (error.data && error.data.description) {
                            if (error.data.description.includes("Unsupported file content type")) {
                                toastr.error($translate.instant("flyers.messages.error.image.file-type"));
                            } else if (error.data.description.includes("size limit")) {
                                toastr.error($translate.instant("flyers.messages.error.image.limit-size"));
                            } else {
                                toastr.error(error.data.description ||
                                    $translate.instant("flyers.messages.error.image.default"));
                            }
                        } else {
                            toastr.error($translate.instant("flyers.messages.error.image.default"));
                        }
                        e.currentTarget.value = null;
                    })
                    .finally(function() {
                        vm.isUploading = false;
                        e.currentTarget.value = null;
                    });
            };
            reader.readAsDataURL(file);
        };
    }

})();

